import { Action } from "../actions/actions";
import { ComponentDefinition, DataHolderComponent, PostRenderedComponent } from "../components/Component";
import { I18nMessageDefinition } from "../i18n/I18nMessage";
import { ConfirmationDialog } from "./confirmationDialog";

export class ConfirmationDialogComponent implements PostRenderedComponent {
    public readonly componentType = "confirmationDialog";
    public id: string;
    public definition: ConfirmationDialogDefinition;
    private dialog: ConfirmationDialog;

    constructor(definition: ConfirmationDialogDefinition) {
        this.definition = definition;

        let dialogDefinition = {
            ...definition,
            acceptCallback: () => {
                definition.action.run(definition.data, definition.component);
            },
        };
        this.dialog = new ConfirmationDialog(dialogDefinition);
    }

    public render(): Element {
        return null;
    }

    public postRender() {
        this.dialog.open();
    }
}

export interface ConfirmationDialogDefinition extends ComponentDefinition {
    confirmationMessages: I18nMessageDefinition[];
    confirmationAccept?: I18nMessageDefinition;
    confirmationDeclineKey?: string;
    data: any;
    component: DataHolderComponent;
    action: Action;
}
